import { defineMessages } from 'react-intl';

export const freightStatusBadgeMessages = defineMessages({
  pending: {
    defaultMessage: 'Pending Pickup',
    id: 'FwRgGI',
    description: 'Freight status badge label for a shipment pending carrier confirmation',
  },
  booked: {
    defaultMessage: 'Awaiting Pickup',
    id: 'eIk5gL',
    description: 'Freight status badge label for a booked shipment awaiting carrier pickup',
  },
  inTransit: {
    defaultMessage: 'In Transit',
    id: '4t8qqD',
    description: 'Freight status badge label for a shipment in transit',
  },
  delivered: {
    defaultMessage: 'Delivered',
    id: 'BRO0CE',
    description: 'Freight status badge label for a delivered shipment',
  },
  exception: {
    defaultMessage: 'Exception',
    id: 'j3/i8I',
    description: 'Freight status badge label for a shipment with a delivery exception',
  },
  quoted: {
    defaultMessage: 'Quoted',
    id: 'yYoIvS',
    description: 'Freight status badge label for a quoted (not yet booked) shipment',
  },
  cancelled: {
    defaultMessage: 'Cancelled',
    id: 'LEM9uw',
    description: 'Freight status badge label for a cancelled shipment',
  },
  unknown: {
    defaultMessage: 'Unknown',
    id: 'EQiH3V',
    description: 'Freight status badge label for an unrecognized shipment status',
  },
});
